import React, { useState } from "react";
import "./Contact.scss";
import bioImage from "../../assets/about/BioHeadshot2022.jpg";
import about1 from "../../assets/about/about1.jpeg";
import about2 from "../../assets/about/about2.jpeg";
import boxIcon from "../../assets/about/squareIcon.png";
import emailjs from "@emailjs/browser";
import {
  EMAILJS_SERVICE_ID,
  EMAILJS_TEMPLATE_ID,
  EMAILJS_PUBLIC_KEY,
} from "../../config/config";

function Contact() {
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    message: "",
    time: "",
  });
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");

  const handleSubmit = (e) => {
    e.preventDefault();
    //check if email and body is filled
    if (
      !formData.email ||
      !formData.message ||
      !formData.firstName ||
      !formData.lastName
    ) {
      setError("Please fill in all required fields.");
      return;
    }

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    if (!emailRegex.test(formData.email)) {
      setError("Please enter a valid email address." );
      return;
    }
    
    setIsLoading(true);
    setError("");
    formData.time = new Date().toLocaleString();
    emailjs
      .send(
        EMAILJS_SERVICE_ID, // your Service ID
        EMAILJS_TEMPLATE_ID, // your Template ID
        formData,
        EMAILJS_PUBLIC_KEY // your Public Key
      )
      .then(
        (result) => {
          setIsLoading(false);
          setSuccess("Email sent, I will get back to you soon!");
        },
        (error) => {
          console.log(error);
          console.error("❌ Error:", error.text);
          setError(
            error.text || "Something went wrong, please try again later."
          );
          setIsLoading(false);
        }
      );

    console.log("Form submitted");
  };

  return (
    <div className="flex flex-col w-full contactContainer">
      <div className="max-w-5xl bioSection">
        <div className="flex flex-col w-full max-w-3xl">
          <p className="text-4xl font-bold text-black font-fugaz mb-2">About</p>
          <p className="bio-text pl-0">
            Jocelyn Gallegos is a queer non-binary Mexican-American filmmaker
            with an emphasis in cinematography and creative direction. They
            attended California State University, Los Angeles where they
            received a Bachelor of Arts in Television, Film and Media Studies
            with Narrative Production pathway. Jocelyn believes cinema has the
            significant ability to build change and understanding. They are most
            passionate about exploring the social and psychological realities
            across the BIPOC and Queer experience, racial and environmental
            justice, and spirituality.
            <br />
            <br />
            As a well-rounded cinematographer, Jocelyn has performed as Camera
            Operator, 1st/2nd AC, Gaffer, Grip, and Editor on a wide variety of
            projects including narrative, commercial, music video, and branded
            content. She has worked with NALIP, BuzzFeed, Women's Mosque of
            America, and Intersectional Environmentalist.
            <br />
            <br />
            In their free time, Jocelyn enjoys crocheting, volunteering with
            mutual aid groups, and playing with their cat, Moony. She is based
            out of Los Angeles and is ready to build visions worldwide.{" "}
          </p>
        </div>
        <div className="bioImageContainer">
          <div className="rowBioImages">
            <img className="bioImage" src={about1} alt="jocelyn" />
            <img className="bioImage" src={bioImage} alt="jocelyn" />
          </div>
          <img
            className="bioImage"
            id="smallBioPic"
            src={about2}
            alt="jocelyn"
          />
        </div>
      </div>

      {/* contact form */}
      <div className="sm:max-w-5xl w-full flex justify-start items-start">
        <form
          className="flex flex-col w-full ml-0 self-start mt-10 sm:mt-0 sm:max-w-xl"
          onSubmit={handleSubmit}
        >
          <p className="text-black font-bold text-4xl font-fugaz mb-2">
            Say Hi
          </p>
          {/* <div className="flex flex-col sm:flex-row w-full">
          <div className="flex flex-col w-full">
            <label className="text-black flex flex-row font-spectral text-lg">
              First Name <p className="text-xl text-red-800">*</p>
            </label>
            <input
              type="text"
              name="firstName"
              required
              className="text-black text-xl h-10 font-sans bg-gray-100 border border-black rounded-sm flex-none"
              value={formData.firstName}
              onChange={(e) =>
                setFormData({ ...formData, firstName: e.target.value })
              }
            />
          </div>
          <div className="flex flex-col w-full mb-2 ml-0 sm:pl-5">
            <label className="text-black flex font-spectralflex-row text-lg">
              Last Name <p className="text-xl text-red-800">*</p>
            </label>
            <input
              type="text"
              name="lastName"
              required
              className="text-black h-10 text-xl font-sans bg-gray-100 border border-black rounded-sm flex-none"
              value={formData.lastName}
              onChange={(e) =>
                setFormData({ ...formData, lastName: e.target.value })
              }
            />
          </div>
        </div>
        <div className="flex flex-col mb-2">
          <label className="flex flex-row font-spectral text-black text-lg">
            Email <p className="text-xl text-red-800">*</p>
          </label>
          <input
            type="email"
            required
            name="email"
            className="text-black h-10 text-xl font-sans w-full bg-gray-100 border border-black rounded-sm flex-none"
            value={formData.email}
            onChange={(e) =>
              setFormData({ ...formData, email: e.target.value })
            }
          />
        </div>
        <div className="flex flex-col justify-center">
          <label className="text-black font-spectral flex flex-row text-lg">
            Body <p className="text-xl text-red-800">*</p>
          </label>
          <textarea
            type="text"
            required
            rows={4}
            name="message"
            className="text-black h-20 text-xl font-sans w-full bg-gray-100 border border-black rounded-sm flex-none"
            value={formData.message}
            onChange={(e) =>
              setFormData({ ...formData, message: e.target.value })
            }
          />
        </div> */}

          <div className="flex flex-col sm:flex-row w-full">
            <FormField
              label="First Name"
              name="firstName"
              value={formData.firstName}
              onChange={(e) =>
                setFormData({ ...formData, firstName: e.target.value })
              }
            />
            <div className="sm:pl-5">

            <FormField
              label="Last Name"
              name="lastName"
              value={formData.lastName}
              onChange={(e) =>
                setFormData({ ...formData, lastName: e.target.value })
              }
              />
              </div>
          </div>

          <FormField
            label="Email"
            name="email"
            value={formData.email}
            onChange={(e) =>
              setFormData({ ...formData, email: e.target.value })
            }
          />

          <FormField
            label="Body"
            name="message"
            textarea
            rows={4}
            value={formData.message}
            onChange={(e) =>
              setFormData({ ...formData, message: e.target.value })
            }
          />
          <button
            type="submit"
            className="text-white bg-black w-28 text-center pl-5 pr-5 pt-1 pb-1 font-fugaz font-bold text-xl mt-5 hover:bg-primary rounded-sm"
          >
            Send
          </button>
          {isLoading && <div className="loader"></div>}
          {error && (
            <p className="text-lg mt-2 text-red-500 font-fugaz">
              {error}
            </p>
          )}
          {success && (
            <p className="text-xl mt-2 text-primary font-fugaz">{success}</p>
          )}
        </form>
      </div>
      {/* contact info */}
      <div className="contact-info">
        <a href={"tel:12092775139"}>209.277.5139</a>
        <a href={"mailto:hello@jocelyngallegos.com"}>
          hello@jocelyngallegos.com
        </a>
        <div className="flex justify-center">
          <img className="logo" src={boxIcon} alt="square" />
        </div>
      </div>
    </div>
  );
}

export default Contact;

function FormField({
  label,
  name,
  type = "text",
  value,
  onChange,
  required = false,
  textarea = false,
  rows = 4,
  className = "",
}) {
  return (
    <div className="flex flex-col w-full mb-2">
      <label className="flex flex-row font-spectral text-black text-lg">
        {label} <p className="text-xl font-bold text-primary ml-1">*</p>
      </label>

      {textarea ? (
        <textarea
          name={name}
          rows={rows}
          required={required}
          className={`text-black text-lg font-sans w-full h-20 pl-1 bg-text-box border border-black rounded-sm flex-none ${className}`}
          value={value}
          onChange={onChange}
        />
      ) : (
        <input
          type={type}
          name={name}
          required={required}
          className={`text-black h-10 text-lg font-sans pl-1 bg-text-box border border-black rounded-sm flex-none ${className}`}
          value={value}
          onChange={onChange}
        />
      )}
    </div>
  );
}
